import { Icon } from "./Icon.tsx";

/** ControlRuleBuilder.tsx's premise-side toggle for "compare to a fixed value", vs. LinkIcon's "compare to another element's attribute". */
export function HashIcon() {
  return (
    <Icon>
      <path d="M4 9h16" />
      <path d="M4 15h16" />
      <path d="M10 3L8 21" />
      <path d="M16 3l-2 18" />
    </Icon>
  );
}
